import { writable } from 'svelte/store';
import type { HistoryEntry, PlanSession } from '$lib/domain/types';
import { historyRepo, planSessionRepo } from '$lib/db/repo';
import { enrichHistoryWithSessions } from '$lib/domain/insights';

export const historySessionsStore = writable<PlanSession[]>([]);

const createHistoryStore = () => {
  const { subscribe, set, update } = writable<HistoryEntry[]>([]);

  const load = async () => {
    const [items, sessions] = await Promise.all([historyRepo.list(), planSessionRepo.listAll()]);
    historySessionsStore.set(sessions);
    const sorted = enrichHistoryWithSessions(items, sessions).sort((a, b) =>
      (b.createdAt ?? '').localeCompare(a.createdAt ?? ''),
    );
    set(sorted);
  };

  const add = async (entry: HistoryEntry) => {
    await historyRepo.add(entry);
    const sessions = await planSessionRepo.listAll();
    historySessionsStore.set(sessions);
    update((items) => enrichHistoryWithSessions([entry, ...items], sessions));
  };

  return { subscribe, load, add };
};

export const historyStore = createHistoryStore();
